// extracted by mini-css-extract-plugin
module.exports = {"panel":"checkpanel_panel__-CMvR","title":"checkpanel_title__LzJll","title_sd":"checkpanel_title_sd__2pfBO"};